import { useContext } from 'react';
import { RouteDataContext } from '@/routes/RouteDataContext';

export const useRouteDataContext = () => {
  return useContext(RouteDataContext);
};
